import { SITE_VOICE } from '../siteVoice';

/** Terminal selection vs app cursor explainer + sample buffer text. */

export const TEXT_SELECTION_SAMPLE_LINES = [
  `${SITE_VOICE.promptPath} $ ls -la`,
  'total 24',
  `drwxr-xr-x  5 ${SITE_VOICE.lsOwnerGroup}  160 Jan  7 10:00 .`,
  `drwxr-xr-x 12 ${SITE_VOICE.lsOwnerGroup}  384 Jan  6 15:30 ..`,
  `-rw-r--r--  1 ${SITE_VOICE.lsOwnerGroup}  234 Jan  7 09:45 README.md`,
  `-rw-r--r--  1 ${SITE_VOICE.lsOwnerGroup} 1024 Jan  7 10:00 build.ts`,
  `drwxr-xr-x  3 ${SITE_VOICE.lsOwnerGroup}   96 Jan  5 14:20 src`,
  `${SITE_VOICE.promptPath} $ echo "${SITE_VOICE.welcomePhrase}"`,
  SITE_VOICE.welcomePhrase,
  `${SITE_VOICE.promptPath} $ _`,
] as const;

export type TextSelectionExplainerStep =
  | 'overview'
  | 'terminal-selection'
  | 'cursor-positioning'
  | 'option-click'
  | 'why-different';

export const TEXT_SELECTION_EXPLAINER_STEPS: Record<
  TextSelectionExplainerStep,
  { title: string; description: string }
> = {
  overview: {
    title: 'Two Types of Selection',
    description:
      "In terminals, there are two completely different 'selections': terminal-level text selection (what the terminal emulator handles) and cursor position (where the app thinks the cursor is). They're independent and often confuse people.",
  },
  'terminal-selection': {
    title: 'Terminal-Level Selection',
    description:
      "When you click and drag in a terminal, the terminal emulator (iTerm, Terminal.app, etc.) handles selection. It's highlighting text on screen for copy/paste. The running program doesn't know you're selecting—it just sees characters on a grid.",
  },
  'cursor-positioning': {
    title: 'App Cursor Position',
    description:
      "The blinking cursor in vim or your shell prompt is controlled by the app, not the terminal. The app sends escape sequences like ESC[5;10H to move the cursor to row 5, column 10. Clicking on the screen doesn't automatically move this cursor.",
  },
  'option-click': {
    title: 'Option+Click: The Bridge',
    description:
      "Some terminals support Option+Click (or Alt+Click) to move the cursor. When you do this, the terminal calculates where you clicked and sends arrow key sequences to move the cursor there. It's simulating keypresses, not directly moving the cursor!",
  },
  'why-different': {
    title: "Why They're Separate",
    description:
      "The terminal is just a character display. It doesn't know if you're in vim (where clicking should move cursor) or running 'cat' (where there's no cursor). The app must opt into mouse handling. Without it, clicks are just for terminal-level selection.",
  },
};
